export default __webpack_public_path__ + "static/media/uob.99ccc232.png";